import gql from 'graphql-tag';
import { lightUserFragment } from './light-user.fragment';

export const notificationFragment = gql`
  fragment notificationFragment on Notification {
    ID
    status
    resourceID
    action
    resourceName

    timestamp

    users {
      ...lightUserFragment
    }
  }

  ${lightUserFragment}
`;
